module.exports = __webpack_public_path__ + "static/media/InventoryIcon.ee28981f.svg";